<template>
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <v-btn icon @click="back"><v-icon>keyboard_arrow_left</v-icon></v-btn>
    <v-toolbar-title>Firma del Cliente</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
   <v-list two-line class="list-view">
          <template>
            <v-list-tile class="list-view-item"
              avatar
              ripple
            >
              <v-list-tile-content>
                <v-form v-model="valid">
                  <div v-if="!owner">
                    <v-text-field 
                    required
                    :rules="required"
                    v-model="text1" 
                    label="Nombre" 
                    type="text">
                  </v-text-field>
                  <v-text-field 
                    required
                    :rules="required"
                    v-model="text3" 
                    label="Comentario" 
                    type="text">
                  </v-text-field>
                  <v-text-field 
                    :rules="carId"
                    required
                    v-model="text2" 
                    label="Cedula" 
                    type="text">
                  </v-text-field>
                  </div>
                
                  <h3 class="title-1">Firmar el recuadro Blanco</h3>
                  <VueSignaturePad class="SignaturePad"
                    width="100%"
                    height="260px"
                    ref="signaturePad"
                    :options="option"
                    />
                  <div class="list-view-item-toolbar">
                    <v-btn color="info"  @click="clear" >Limpiar</v-btn>
                    <v-btn color="success" :disabled="!valid" @click="save" >Guardar Firma</v-btn>
                  </div>
                </v-form>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
        
        </v-flex>
  </v-layout>
</template>

<script>
import Store from '../store'
import router from '../router'
export default {
  created () {
    this.owner = (this.selectOwner === 'true')
  },
  mounted () {
    if (this.owner) {
      this.text1 = 'null'
      this.text2 = 123456789
      this.text3 = 'null'
      this.valid = this.owner
    }
  },
  data () {
    return {
      owner: false,
      clipped: false,
      e1: 0,
      valid: false,
      text1: '',
      text2: '',
      text3: '',
      required: [
        v => !!v || 'El campo es requerido'
      ],
      carId: [
        v => !!v || 'El campo es requerido',
        v => (/^\d+$/.test(v) && v.length === 10) || 'Debe introdicir un numero de cedula sin guines'
      ],
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255,255,255)'
      }
    }
  },
  computed: {
    login: () => {
      return Store.getters.login
    }
  },
  props: ['selectOwner'],
  name: 'App',
  methods: {
    back: () => {
      router.go(-1)
    },
    save: function () {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature()
      console.log(isEmpty)
      var formData = new FormData()
      formData.append('imageData', data)
      formData.append('id', this.id)
      fetch('http://www.mdev.onecontrolcargosystem.com/upload.php', {
        method: 'POST',
        body: formData
      })
    },
    clear: function () {
      this.$refs.signaturePad.undoSignature()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
  .list-view{
    padding-bottom: 0 !important;
  }
</style>
